<div
  class="min-h-screen flex items-center justify-center bg-white min-[600px]:bg-[url('/assets/images/bg-img.jpg')] bg-no-repeat bg-center bg-cover min-[600px]:py-10">
  <div class="relative w-full max-w-[600px] min-[600px]:max-w-md bg-white min-[600px]:rounded-2xl flex flex-col
    min-h-screen min-[600px]:min-h-[650px] min-[600px]:h-auto min-[600px]:max-h-[calc(100dvh-5rem)] overflow-hidden"
    [ngClass]="shouldLockAuthScroll() ? '' : 'scroll-hidden'">
    @if (shouldLockAuthScroll()) {
    <div (click)="isShowBlur.set(false)"
      class="absolute inset-0 z-50 flex flex-col items-center justify-center bg-gray-500/40 px-6 text-center backdrop-blur-sm">
      <img class="mb-4 h-36 w-36" src="assets/SVG/term-hand.svg" alt="Terms" />
      <p class="max-w-xs text-md font-semibold leading-relaxed text-white">
        {{ 'terms.TO_PROCEED_PLEASE_REVIEW_AND_ACCEPT_THE_TERMS_AND_CONDITIONS' | translate }}
      </p>
    </div>
    }

    <div class="w-full flex items-start px-4 py-8 md:py-6 shrink-0" [class.scroll-header]="screenWidth() <= 600">
      <div class="w-16 shrink-0 flex items-center justify-start">
        <ng-container appPortalHost></ng-container>
      </div>

      <div class="min-w-0 flex-1 px-3 text-center">
        <h1 [ngClass]="currentLang==='ar'?'text-xl':'text-xs sm:text-2xl'"
          class="truncate font-bold tracking-wide" [class.text-white]="screenWidth() <= 600"
          [class.text-[var(--primary-color)]]="screenWidth() > 600" [title]="title() | translate">
          {{ title() | translate }}
        </h1>
      </div>

      <div class="w-16 shrink-0 flex items-center justify-end">
        @if (
          (router.url.split('/').pop() === 'login' && _loginStep.currentStep() === 1) ||
          (router.url.split('/').pop() === 'signup' && _signupStep.currentStep() === 1)
        ) {
        <button type="button"
          (click)="openLanguagePopUp()"
          class="flex items-center justify-center gap-2 rounded-full px-3 py-1 text-sm cursor-pointer"
          [class.bg-white]="screenWidth() <= 600" [class.bg-[var(--primary-color)]]="screenWidth() > 600">
          <img class="h-6 w-6" [src]="currentLang === 'en' ? 'assets/SVG/en-flag.svg' : 'assets/SVG/ar-flag.svg'"
            alt="Language" />
          <span class="font-semibold" [class.text-white]="screenWidth() > 600"
            [class.text-[var(--primary-color)]]="screenWidth() <= 600">
            {{ currentLang === 'en' ? 'EN' : 'AR' }}
          </span>
        </button>
        } @else {
        <div class="h-6 w-6"></div>
        }
      </div>
    </div>

    <div class="flex-1 min-h-0 overflow-y-auto scroll-hidden scrollable px-6 py-6 sm:px-7 md:py-8">
      <app-global-loader />
      <router-outlet />
      <app-toast-container />
    </div>
  </div>
</div>

@if (isLangPopUpVisible()) {
<app-language-modal [isPopUpVisible]="isLangPopUpVisible"></app-language-modal>
}
